/**
 * Normalize a domain string to a canonical form.
 *
 * - Trims whitespace
 * - Lowercases the string
 * - Removes protocol prefixes (http://, https://)
 * - Removes common subdomain prefixes (www., m.)
 * - Removes a trailing slash
 *
 * @param d Optional input string containing a URL or domain.
 * @returns Canonicalized domain string (may be empty string if input is null/empty).
 */
export function normalizeDomain(d?: string | null): string {
    return (d || '')
        .trim()
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '')
        .replace(/^m\./, '')
        .replace(/\/$/, '');
}


